import React from "react";
import { Outlet, NavLink } from "react-router-dom";

const tabs: { to: string; label: string; end?: boolean }[] = [
  { to: ".", label: "Dashboard", end: true },
  { to: "register", label: "Register" },
  { to: "inspections", label: "Inspections" },
  { to: "contractors", label: "Contractors" },
  { to: "evidence", label: "Evidence" },
  { to: "reports", label: "Reports" },
  { to: "notifications", label: "Notifications" },
  { to: "audit-trail", label: "Audit Trail" },
];

export const ComplianceModule: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="border-b border-gray-200">
        <nav
          className="-mb-px flex flex-wrap gap-x-6"
          aria-label="Compliance tabs"
        >
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                `whitespace-nowrap py-3 px-1 border-b-2 text-sm font-medium ${
                  isActive
                    ? "border-primary-600 text-primary-700"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
};
